import { Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, makeStyles, MuiThemeProvider, TextField, Tooltip, Typography } from '@material-ui/core'
import AddIcon from "@material-ui/icons/Add"
import DeleteIcon from "@material-ui/icons/Delete"
import FileSaver from 'file-saver'
import MUIDataTable from 'mui-datatables'
import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import JSONEditor from '../../components/json-editor/JSONEditor'
import ListableCard from '../../components/listable-card/ListableCard'
import { Loading } from '../../components/loading/Loading'
import PageContainer from '../../components/page-container/PageContainer'
import CustomizedSnackbars from '../../components/snackbar/Snackbar'
import SimpleTable from '../../components/table/Table'
import ScrollableTabs from '../../components/tabs/Tabs'
import { DeleteModal } from '../../containers/delete-modal/DeleteModal'
import FileDropModal from '../../containers/file-drop-modal/FileDropModal'
import GenericPickerModal from '../../containers/generic-picker-modal/GenericPickerModal'
import { addRelationship, clearObjectivesForNode, clearSellingWeeksForNode, deleteNode, deleteRelationship, getBarcodesForNode, getFeatureFlagsForNode, getHierarchy, getNode, getObjectivesForNode, getSellingWeeksForNode, getUsersForNode, setObjectivesForNode, updateBarcodesForNode, updateFeatureFlagsForNode, updateSellingWeeksForNode, updateUsersForNode } from '../../state/actions/HierarchyActions'
import { getObjectives } from '../../state/actions/ObjectiveActions'
import { clearUsers, getUsers, getUsersById, GET_USER_SIZE } from '../../state/actions/UserActions'
import { ObjectiveType } from '../../state/constants/ObjectiveConstants'

const useStyles = makeStyles({
    contentGrid: {
        margin: "30px",
        height: "100%"
    },
    tableWrapper: {
        maxHeight: "400px",
        overflow: "auto"
    },
    JSONEditor: {
        height: "calc(100% - 60px)",
        overflow: "scroll"
    },
    fullscreen: {
        height: "100%"
    },
    featureFlagGrid: {
        margin: "30px",
        height: "calc(100% - 60px)"
    },
    clickableText: {
        color: "#4C73FF",
        fontWeight: 400,
        cursor: "pointer"
    }
})

function ViewHierarchyPage(props) {
    const currentNode = useSelector(state => state.HierarchyReducer.currentNode)
    const currentNodeBarcodes = useSelector(state => state.HierarchyReducer.currentNodeBarcodes)
    const currentNodeUsers = useSelector(state => state.HierarchyReducer.currentNodeUsers)
    const currentNodeSellingWeeks = useSelector(state => state.HierarchyReducer.currentNodeSellingWeeks)
    const currentNodeFeatureFlags = useSelector(state => state.HierarchyReducer.currentNodeFeatureFlags)
    const currentNodeObjectives = useSelector(state => state.HierarchyReducer.currentNodeObjectives)

    const hierarchy = useSelector(state => state.HierarchyReducer.hierarchy)
    const users = useSelector(state => state.UserReducer.users)
    const continuationToken = useSelector(state => state.UserReducer.continuationToken)
    const objectives = useSelector(state => state.ObjectivesReducer.objectives)
    const assignedUsers = useSelector(state => state.UserReducer.assignedUsers)

    const [t, i18n] = useTranslation()
    const classes = useStyles()
    const dispatch = useDispatch()

    const [deleteNodeModalOpen, setDeleteNodeModalOpen] = useState(false)
    const [deleteRelationshipModalOpen, setDeleteRelationshipModalOpen] = useState(false)
    const [deleteBarcodeModalOpen, setDeleteBarcodeModalOpen] = useState(false)
    const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false)
    const [deleteSellingWeeksModalOpen, setDeleteSellingWeeksModalOpen] = useState(false)
    const [deleteObjectivesModalOpen, setDeleteObjectivesModalOpen] = useState(false)

    const [addParentModalOpen, setAddParentModalOpen] = useState(false)
    const [addChildModalOpen, setAddChildModalOpen] = useState(false)
    const [addBarcodeModalOpen, setAddBarcodeModalOpen] = useState(false)
    const [addUserModalOpen, setAddUserModalOpen] = useState(false)
    const [addSellingWeeksModalOpen, setAddSellingWeeksModalOpen] = useState(false)
    const [addObjectivesModalOpen, setAddObjectivesModalOpen] = useState(false)

    const [clearDataModalOpen, setClearDataModalOpen] = useState(false)

    const [loading, setLoading] = useState(false)
    const [parentsLoading, setParentsLoading] = useState(false)
    const [childrenLoading, setChildrenLoading] = useState(false)
    const [barcodeLoading, setBarcodeLoading] = useState(false)
    const [userLoading, setUserLoading] = useState(false)
    const [sellingWeeksLoading, setSellingWeeksLoading] = useState(false)
    const [featureFlagsLoading, setFeatureFlagsLoading] = useState(false)

    const [fetchHierarchy, setFetchHierarchy] = useState(false)
    const [fetchBarcodes, setFetchBarcodes] = useState(false)
    const [fetchNodeUsers, setFetchNodeUsers] = useState(false)
    const [fetchCurrentNode, setFetchCurrentNode] = useState(true)
    const [fetchNodeSellingWeeks, setFetchNodeSellingWeeks] = useState(false)
    const [fetchNodeFeatureFlags, setFetchNodeFeatureFlags] = useState(false)
    const [fetchAssignedUsers, setFetchAssignedUsers] = useState(false)

    const [deleteChildrenFlag, setDeleteChildrenFlag] = useState(false)

    const [relationshipsToDelete, setRelationshipsToDelete] = useState([])
    const [barcodesToDelete, setBarcodesToDelete] = useState([])
    const [usersToDelete, setUsersToDelete] = useState([])
    const [sellingWeeksToDelete, setSellingWeeksToDelete] = useState([])
    const [objectivesToDelete, setObjectivesToDelete] = useState([])

    const [currentNodeChildren, setCurrentNodeChildren] = useState([])
    const [file, setFile] = useState(null)
    const [barcodeValue, setBarcodeValue] = useState("")

    const [selectedSellingWeeks, setSelectedSellingWeeks] = useState([])

    const [editingSellingWeeks, setEditingSellingWeeks] = useState(false)
    const [error, setError] = useState(null)
    const [editingFeatureFlags, setEditingFeatureFlags] = useState(false)
    const [showFeatureFlagDialog, setShowFeatureFlagDialog] = useState(false)

    const [editedNodeFeatureFlags, setEditedNodeFeatureFlags] = useState(Object.values(currentNodeFeatureFlags))

    const [hasNewData, setHasNewData] = useState(true)
    const [firstUserFetch, setFirstUserFetch] = useState(true)
    const [lastSearch, setLastSearch] = useState("")
    const [loadingUsers, setLoadingUsers] = useState(false)

    const [addRelationshipTrigger, setAddRelationshipTrigger] = useState(null)

    /**
     * Startup Effect for fetching the main heirarchy, along with all admin_route objectives
     */
    useEffect(() => {
        dispatch(getHierarchy(() => {

        }))

        // dispatch(getObjectives([ObjectiveType().admin_route.key], () => {

        // }))
    }, [])

    /**
     * Effect for fetching the current node from the hierarchy, by id.
     * Triggered by changes to fetchCurrentNode
     */
    useEffect(() => {
        if (fetchCurrentNode) {
            setLoading(true)

            dispatch(getNode(props.match.params.hierarchyId, () => {
                setLoading(false)
                setFetchCurrentNode(false)
            }))
        }
    }, [fetchCurrentNode])

    /**
     * Effect for retrieving current nodes children
     * Triggered by changes to current node
     */
    useEffect(() => {
        getChildren()
    }, [currentNode])

    /**
 * Effect for retrieving current nodes other data
 * Including: barcodes, users, selling weeks, feature flags, objectives
 * Triggered by changes to current node
 */
    useEffect(() => {
        if (currentNode != null && currentNode.id != null) {
            const nodeId = props.match.params.hierarchyId
            setBarcodeLoading(true)
            setUserLoading(true)
            setSellingWeeksLoading(true)
            dispatch(getBarcodesForNode(nodeId, () => {
                setBarcodeLoading(false)
            }))
            dispatch(getUsersForNode(nodeId, () => {
                setUserLoading(false)
                setFetchAssignedUsers(true)
            }))
            dispatch(getSellingWeeksForNode(nodeId, () => {
                setSellingWeeksLoading(false)
            }))
            // feature flags
            dispatch(getFeatureFlagsForNode(nodeId, () => {
                setFeatureFlagsLoading(false)
            }))
            // dispatch(getObjectivesForNode(nodeId, () => {

            // }))
        }
    }, [currentNode])

    /**
     * Effect for retrieving updates to the hierarchy
     * Triggered by changes to fetchHierarchy
     */
    useEffect(() => {
        if (fetchHierarchy) {
            dispatch(getHierarchy(() => {
                setFetchHierarchy(false)
                setFetchCurrentNode(true)
            }))
        }
    }, [fetchHierarchy])

    /**
     * Effect for retrieving barcodes for the current node
     * Triggered by changes to fetchBarcodes
     */
    useEffect(() => {
        if (fetchBarcodes) {
            setBarcodeLoading(true)
            dispatch(getBarcodesForNode(currentNode.id, () => {
                setBarcodeLoading(false)
                setFetchBarcodes(false)
            }))
        } else {
            setFetchBarcodes(false)
        }
    }, [fetchBarcodes])

    /**
     * Effect for retrieving users for the current node
     * Triggered by changes to fetchNodeUsers
     */
    useEffect(() => {
        if (fetchNodeUsers) {
            dispatch(getUsersForNode(currentNode.id, () => {
                setFetchAssignedUsers(true)
                setFetchNodeUsers(false)
            }))
        }
    }, [fetchNodeUsers])

    /**
     * Effect for retrieving selling weeks for the current node
     * Triggered by changes to fetchNodeSellingWeeks
     */
    useEffect(() => {
        if (fetchNodeSellingWeeks) {
            setSellingWeeksLoading(true)
            dispatch(getSellingWeeksForNode(currentNode.id, () => {
                setSellingWeeksLoading(false)
                setFetchNodeSellingWeeks(false)
            }))
        } else {
            setFetchNodeSellingWeeks(false)
        }
    }, [fetchNodeSellingWeeks])

    /**
     * Effect for retrieving feature flags for the current node
     * Triggered by changes to fetchNodeFeatureFlags
     */
    useEffect(() => {
        if (fetchNodeFeatureFlags) {
            setFeatureFlagsLoading(true)
            dispatch(getFeatureFlagsForNode(currentNode.id, () => {
                setFeatureFlagsLoading(false)
                setFetchNodeFeatureFlags(false)
            }))
        } else {
            setFetchNodeFeatureFlags(false)
        }
    }, [fetchNodeFeatureFlags])

    /**
     * Effect for saving edits to the feature flags data before sending to cosmos
     * Triggered by changes to currentNodeFeatureFlags
     */
    useEffect(() => {
        setEditedNodeFeatureFlags(Object.values(currentNodeFeatureFlags))
    }, [currentNodeFeatureFlags])

    /**
     * Effect for retrieving user data of assigned users from ids
     * Triggered by changes to fetchAssignedUsers
     */
    useEffect(() => {
        const userList = Object.values(currentNodeUsers || {})
        if (fetchAssignedUsers && userList.length > 0) {
            setUserLoading(true)
            dispatch(getUsersById(userList, () => {
                setUserLoading(false)
                setFetchAssignedUsers(false)
            }))
        } else {
            setFetchAssignedUsers(false)
        }
    }, [fetchAssignedUsers])

    /**
     * Effect for checking continuationTokens are for search or base user fetches
     * Triggered by changes to continuationToken
     */
    useEffect(() => {
        const searchData = continuationToken?.search != null
        const baseData = continuationToken?.base != null
        setHasNewData(searchData || baseData)
        if (!searchData) {
            setLastSearch("")
        }
    }, [continuationToken])

    /**
     * Effect for adding a relationships between a source node and others
     * Triggere by changes to addRelationshipTrigger
     */
    useEffect(() => {
        // Add a relationship when triggered, but only if the current node is available and has an id
        if (addRelationshipTrigger != null && currentNode != null && currentNode.id != null) {
            dispatch(addRelationship(currentNode.id, addRelationshipTrigger.values, addRelationshipTrigger.sourceIsParent, () => {
                setAddRelationshipTrigger(null)
                setFetchHierarchy(true)
            }))
        } else {
            setAddRelationshipTrigger(null)
            setFetchHierarchy(true)
        }
    }, [addRelationshipTrigger])

    function getChildren() {
        const children = []

        Object.values(hierarchy).forEach(obj => {
            if (obj != null && obj.Parents != null) {
                if (obj.Parents.includes(currentNode.id)) {
                    children.push(obj.id);
                }
            }
        });

        setCurrentNodeChildren(children)
    }

    function getNodesForIds(nodeIds) {

        if (nodeIds != null) {
            return nodeIds.map(nodeId => {

                const node = hierarchy[nodeId];

                if (node != null) {
                    return { id: node.id, Name: node.DisplayName };
                }

                return {};
            });
        }

        return [];
    }

    function getBarcodes(barcodes) {
        if (barcodes != null) {
            return barcodes.map(barcode => {

                if (barcode != null) {
                    return { id: barcode, Name: barcode };
                }

                return {};
            });
        }

        return [];
    }

    function getNodeUsers(nodeUsers) {
        if (nodeUsers != null) {
            return nodeUsers.map(nodeUserId => {

                const nodeUser = assignedUsers[nodeUserId];

                if (nodeUser != null) {
                    return { id: nodeUser.id, Name: nodeUser.displayName || nodeUser.name };
                }

                return { id: nodeUserId, Name: "Bad User Data" };
            });
        }

        return [];
    }

    function getSellingWeeks(sellingWeeks) {
        return sellingWeeks.map(item => (
            {
                id: item.id,
                FinancialPeriodNumber: item.financialPeriodNumber,
                FinancialYear: item.financialYear,
                SellingWeekStartDate: item.sellingWeekStartDate,
                SellingWeekEndDate: item.sellingWeekEndDate,
                SellingWeekNumber: item.sellingWeekNumber,
                NodeId: item.nodeId
            }
        ))
    }

    function getNodeObjectives(nodeObjectives) {
        if (nodeObjectives != null) {
            return nodeObjectives.map(objectiveId => {

                const nodeObjective = objectives[objectiveId];

                if (nodeObjective != null) {
                    return { id: nodeObjective.id, Name: nodeObjective.Title };
                }

                return {};
            });
        }

        return [];
    }

    function handleParentNodeSelection(nodeList) {
        const values = nodeList
        setAddParentModalOpen(false)

        // only one parent relationship is allowed
        if (currentNode.Parents != null && currentNode.Parents.length > 0) {
            dispatch(deleteRelationship(currentNode.id, currentNode.Parents, () => {
                if (values != null && values.length > 0) {
                    setAddRelationshipTrigger({ values: values, sourceIsParent: false })
                }
            }))
        } else if (values != null && values.length > 0) {
            setAddRelationshipTrigger({ values: values, sourceIsParent: false })
        }
    }

    function handleChildNodeSelection(nodeList) {
        const values = nodeList

        setAddChildModalOpen(false)

        // check for parent relationships
        values.forEach(nodeId => {
            var node = hierarchy[nodeId]
            if (node != null) {
                if (node.Parents != null && node.Parents.length > 0) {
                    // node has parent, delete parent
                    dispatch(deleteRelationship(node.id, node.Parents, () => {
                        if (values != null && values.length > 0) {
                            setAddRelationshipTrigger({ values: values, sourceIsParent: true })
                        }
                    }))
                } else if (values != null && values.length > 0) {
                    // no parent, add as child
                    setAddRelationshipTrigger({ values: values, sourceIsParent: true })
                }
            }
        })
    }

    function handleUpdateBarcodes() {
        if (barcodeValue != "") {
            dispatch(updateBarcodesForNode(currentNode.id, [barcodeValue], () => {
                setFetchBarcodes(true)
                setAddBarcodeModalOpen(false)
                setBarcodeValue("")
            }))
        }
    }

    function handleUpdateUsers(userList) {

        const values = userList
        setAddUserModalOpen(false)
        dispatch(updateUsersForNode(currentNode.id, values, () => {
            setFetchNodeUsers(true)
        }))
    }

    function handleRelationshipDeletion() {
        setDeleteRelationshipModalOpen(false)
        dispatch(deleteRelationship(currentNode.id, relationshipsToDelete, () => {
            setFetchHierarchy(true)
        }))
    }

    function handleUpdateSellingWeeks(sellingWeeks) {
        setAddSellingWeeksModalOpen(false)
        dispatch(updateSellingWeeksForNode(currentNode.id, sellingWeeks, () => {
            setFetchNodeSellingWeeks(true)
        }))
    }

    function handleClearSellingWeeks() {
        setDeleteSellingWeeksModalOpen(true)
    }

    function parseUpload(fileUpload) {
        if (fileUpload != null && fileUpload.size > 0) {
            const fileReader = new FileReader()

            const eventListener = (event) => {

                let csvdata = event.target.result;

                var finalList = []

                var trimmedCSVData = csvdata.trim()

                var objectList = trimmedCSVData.split('\n')
                // Remove headers
                objectList.splice(0, 1)
                objectList.forEach(value => {
                    const sellingWeek = {
                        id: null,
                        FinancialPeriodNumber: null,
                        FinancialYear: null,
                        SellingWeekStartDate: null,
                        SellingWeekEndDate: null,
                        SellingWeekNumber: null,
                        NodeId: null
                    }
                    const headers = ["FinancialPeriodNumber", "FinancialYear", "SellingWeekStartDate", "SellingWeekEndDate", "SellingWeekNumber", "NodeId"]
                    value.split(",").forEach((item, index) => {
                        if (item != "" && item != "\n" && item.trim().item != 0) {
                            sellingWeek[headers[index]] = item.trim()
                        }
                    });
                    sellingWeek.id = `${sellingWeek.FinancialPeriodNumber}+${sellingWeek.SellingWeekStartDate}+${sellingWeek.NodeId}`

                    finalList.push(sellingWeek)
                })


                var sellingWeeks = finalList;


                if (sellingWeeks.some(e => e.NodeId != currentNode.id)) {
                    setAddSellingWeeksModalOpen(false)
                    setError(t('hierarchy.upload-failed-message'))
                } else {
                    setFile(fileUpload)
                    handleUpdateSellingWeeks(fileUpload)
                }
            }

            fileReader.addEventListener('load', eventListener);

            fileReader.readAsBinaryString(fileUpload);
        } else {
            setError(t('hierarchy.upload-failed-empty-message'))
        }
    }

    function generateCSV(items) {
        let csv = ""
        const headers = ["FinancialPeriodNumber", "FinancialYear", "SellingWeekStartDate", "SellingWeekEndDate", "SellingWeekNumber", "NodeId"]
        // If this is the first row, generate the headings
        csv += headers.join(',') + '\r\n'

        // Loop the array of objects
        for (let row = 0; row < items.length; row++) {
            const rowData = Object.assign({}, items[row])

            const csvDataLine = {
                FinancialPeriodNumber: rowData.financialPeriodNumber,
                FinancialYear: rowData.financialYear,
                SellingWeekStartDate: rowData.sellingWeekStartDate,
                SellingWeekEndDate: rowData.sellingWeekEndDate,
                SellingWeekNumber: rowData.sellingWeekNumber,
                NodeId: rowData.nodeId
            }

            let keysAmount = Object.keys(csvDataLine).length
            let keysCounter = 0

            for (let key in csvDataLine) {
                csv += csvDataLine[key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                keysCounter++
            }

            keysCounter = 0
        }
        return 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv)
    }

    function handleUpdateFeatureFlags(data) {
        // Call dispatch for feature flags
        setShowFeatureFlagDialog(false)
        dispatch(updateFeatureFlagsForNode(currentNode.id, data, (success, error) => {
            if (success) {
                setEditingFeatureFlags(false)
                setFetchNodeFeatureFlags(true)
            } else {
                setError(error.message)
            }
        }))
    }

    function handleAddFeatureFlag() {
        const nodeFeatureFlags = Object.assign([], editedNodeFeatureFlags)
        const flag = {
            Name: "",
            SuperList: "",
            HasPermission: true,
            Order: 0,
            Suborder: 0,
            UserRoles: []
        }

        nodeFeatureFlags.push(flag)
        setEditedNodeFeatureFlags(nodeFeatureFlags)
    }

    function getNextPage(value = "") {

        var searchValue = value
        if (value == "" && lastSearch != "" && continuationToken?.search != null) {
            searchValue = lastSearch
        }

        if (value != "") {
            setLastSearch(value)
        }

        let promiseResolver

        dispatch(getUsers(() => {
            setFirstUserFetch(false)
            setLoadingUsers(false)
            promiseResolver()

        }, GET_USER_SIZE.LARGE, searchValue != "" ? continuationToken?.search : continuationToken?.base, searchValue, searchValue == ""))

        return new Promise((resolve) => {
            promiseResolver = resolve
            setLoadingUsers(true)
        })
    }

    function handleAddUserModalCancel() {
        setUserLoading(true)
        setFetchNodeUsers(true)
        setAddUserModalOpen(false)
    }

    function handleAddObjectivesModalCancel() {
        setAddObjectivesModalOpen(false)
    }

    function handleUpdateObjectives(objectives) {
        const updatedObjectives = currentNodeObjectives
            .concat(objectives)
            .filter((value, index, self) => self.indexOf(value) === index)

        setAddObjectivesModalOpen(false)
        dispatch(setObjectivesForNode(currentNode.id, updatedObjectives, () => {

        }))
    }

    function handleDeleteObjectives() {
        const updatedObjectives = currentNodeObjectives.filter(objId => !objectivesToDelete.includes(objId))

        setDeleteObjectivesModalOpen(false)
        dispatch(setObjectivesForNode(currentNode.id, updatedObjectives, () => {

        }))
    }

    function createHeaders() {
        return [
            {
                id: "FinancialPeriodNumber",
                clickable: false,
                align: "left",
                label: t('hierarchy.financial-period-number')
            },
            {
                id: "FinancialYear",
                clickable: false,
                align: "left",
                label: t('hierarchy.financial-year')
            },
            {
                id: "SellingWeekStartDate",
                clickable: false,
                align: "left",
                label: t('hierarchy.start-date')
            },
            {
                id: "SellingWeekEndDate",
                clickable: false,
                align: "left",
                label: t('hierarchy.end-date')
            },
            {
                id: "SellingWeekNumber",
                clickable: false,
                align: "left",
                label: t('hierarchy.week-number')
            }
        ];
    }

    function createCells(headers) {
        let cells = [];

        headers.forEach(header => {
            let cell = { id: header.id };

            if (header.hasOwnProperty("action")) {
                cell.handleClick = (event, row) => {
                    let path = header.action.path.replace(
                        "{id}",
                        row[header.action.identifier]
                    );
                    this.props.history.push(path);
                };
            }

            cell.align = header.align;
            cell.clickable = header.clickable;

            cells.push(cell);
        });

        return cells;
    }

    function renderList() {
        const headers = createHeaders();
        const cells = createCells(headers);

        return (
            <Card>
                <CardHeader
                    title={t('hierarchy.selling-days')}
                    action={
                        <ButtonGroup>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => handleClearSellingWeeks()}
                            >
                                {t('hierarchy.clear-selling-days')}
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                    const csvFile = generateCSV(Object.values(currentNodeSellingWeeks))
                                    FileSaver.saveAs(csvFile, "Selling Days.csv")

                                }}
                            >
                                {t('csv.download')}
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                    setAddSellingWeeksModalOpen(true)
                                }}
                            >
                                {t('csv.upload')}
                            </Button>
                        </ButtonGroup>
                    }
                />
                <CardContent>
                    {sellingWeeksLoading ?
                        <Loading /> :
                        <SimpleTable
                            editable={false}
                            maxHeight="400px"
                            isSticky
                            handleSelection={selectedIds => {
                                setSelectedSellingWeeks(selectedIds)
                            }}
                            dataId={"id"}
                            headers={headers}
                            cells={cells}
                            isSelectable={false}
                            rows={getSellingWeeks(Object.values(currentNodeSellingWeeks != null ? currentNodeSellingWeeks : {}))}
                        />
                    }

                </CardContent>
            </Card>
        )
    }

    function renderMetadata(group) {
        const cards = [
            { type: "title", title: t('hierarchy.hierarchy-data'), width: 12 },
            {
                add: t('hierarchy.add-parents-relationships'),
                buttonAction: () => {
                    setAddParentModalOpen(true)
                },
                handleDelete: (relationships) => {
                    setRelationshipsToDelete(relationships)
                    setDeleteRelationshipModalOpen(true)
                },
                isLoading: () => { return parentsLoading },
                title: t('hierarchy.parent-relationship'),
                emptyPlaceholder: t('hierarchy.no-parents'),
                data: getNodesForIds(currentNode.Parents),
                type: "parents",
                url: "hierarchies",
                clickable: true,
                width: 6
            },
            {
                add: t('hierarchy.add-children-relationships'),
                buttonAction: () => {
                    setAddChildModalOpen(true)
                },
                handleDelete: (relationships) => {
                    setRelationshipsToDelete(relationships)
                    setDeleteRelationshipModalOpen(true)
                },
                isLoading: () => { return childrenLoading },
                title: t('hierarchy.children-relationships'),
                emptyPlaceholder: t('hierarchy.no-children'),
                data: getNodesForIds(currentNodeChildren),
                type: "children",
                url: "hierarchies",
                clickable: true,
                width: 6
            },
            { type: "title", title: t('hierarchy.metadata'), width: 12 },
            {
                add: t('hierarchy.add-barcode'),
                buttonAction: () => {
                    setAddBarcodeModalOpen(true)
                },
                handleDelete: (barcodes) => {
                    setBarcodesToDelete(barcodes)
                    setDeleteBarcodeModalOpen(true)
                },
                isLoading: () => { return barcodeLoading },
                title: t('hierarchy.barcodes'),
                emptyPlaceholder: t('hierarchy.no-barcodes'),
                data: getBarcodes(Object.values(currentNodeBarcodes)),
                type: "barcodes",
                clickable: false,
                width: 6
            },
            {
                add: t('route.add-user'),
                buttonAction: () => {
                    setAddUserModalOpen(true)
                },
                handleDelete: (users) => {
                    setUsersToDelete(users)
                    setDeleteUserModalOpen(true)
                },
                isLoading: () => { return userLoading },
                title: t('user.users'),
                emptyPlaceholder: t('hierarchy.no-users'),
                data: getNodeUsers(Object.values(currentNodeUsers)),
                type: "users",
                url: "users",
                clickable: true,
                width: 6
            }
        ];

        return (
            <Box className={classes.contentGrid}>
                <Grid container spacing={3}>
                    {cards.map(card => {
                        if (card.type === "title") {
                            return (
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography variant="h5">{card.title}</Typography>
                                </Grid>
                            );
                        }

                        return (
                            <Grid item xs={card.width * 2} sm={card.width * 2} md={card.width * 2} lg={card.width} xl={card.width}>
                                <ListableCard
                                    actionButton={[
                                        <Button
                                            onClick={card.buttonAction}
                                            variant="outlined"
                                            color="secondary"
                                        >
                                            {card.add}
                                        </Button>
                                    ]}
                                    addLabel={card.add}
                                    isLoading={card.isLoading()}
                                    title={card.title}
                                    emptyPlaceholder={card.emptyPlaceholder}
                                    handleDelete={card.handleDelete}
                                    onClick={card.clickable ? id => {
                                        props.history.push(`/${card.url}/${id}`)
                                        setFetchCurrentNode(true)
                                    } : null}
                                    data={card.data == null ? [] : card.data}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        );
    }

    function renderSellingWeeks() {
        return (
            <Box className={classes.contentGrid}>
                {renderList()}
            </Box>
        )
    }

    function renderFeatureFlags() {
        var error
        var featureFlags
        try {
            featureFlags = JSON.stringify(editedNodeFeatureFlags, null, 4);
        } catch (error) {
            error = error
            featureFlags = null

        }
        return (
            <Box className={classes.featureFlagGrid}>
                <Card classes={{ root: classes.fullscreen }}>
                    <CardHeader
                        title={t('hierarchy.feature-flags')}
                        action={
                            <ButtonGroup>
                                {
                                    editingFeatureFlags ?
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => {
                                                handleAddFeatureFlag()
                                            }}
                                        >
                                            {t('hierarchy.add-feature-flag')}
                                        </Button> :
                                        null
                                }
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => {
                                        if (editingFeatureFlags) {
                                            setShowFeatureFlagDialog(true)
                                        } else {
                                            setEditingFeatureFlags(true)
                                        }
                                    }}
                                >
                                    {editingFeatureFlags ? t('common.done') : t('common.edit')}
                                </Button>
                            </ButtonGroup>
                        }
                    />
                    <CardContent className={classes.fullscreen}>
                        {featureFlagsLoading ?
                            <Loading /> :
                            <Box className={classes.JSONEditor}>
                                {error == null ?
                                    <JSONEditor
                                        data={featureFlags || "[]"}
                                        dialogOpen={showFeatureFlagDialog}
                                        dialogTitle={t('hierarchy.overriding-feature-flags')}
                                        dialogMessage={t('hierarchy.override-flag-description')}
                                        isEditing={editingFeatureFlags}
                                        handleCloseDialog={() => {
                                            setEditingFeatureFlags(false)
                                            setShowFeatureFlagDialog(false)
                                        }}
                                        handleUpdate={handleUpdateFeatureFlags}
                                    /> :
                                    error
                                }

                            </Box>
                        }
                    </CardContent>
                </Card>
            </Box>
        )
    }

    function renderObjectives() {
        const options = {
            elevation: 0,
            filter: false,
            responsive: "standard",
            rowsPerPage: 10,
            rowsPerPageOptions: [10, 25, 50],
            viewColumns: true,
            filterType: "checkbox",
            print: false,
            download: false,
            selectableRows: "multiple",
            rowHover: true,
            onRowClick: (rowData, rowMeta) => {
                const objectiveId = currentNodeObjectives[rowMeta.rowIndex]
                props.history.push(`/objectives${objectiveId != null ? `/${objectiveId}` : ""}`)
            },
            onRowsDelete: (rowsDeleted, data) => {
                var toDelete = Object.values(rowsDeleted.data).map(item => {
                    const objectiveIdList = currentNodeObjectives
                    if (objectiveIdList != null) {
                        const objective = objectiveIdList[item.dataIndex] != null ? objectiveIdList[item.dataIndex] : {}
                        return objective
                    }
                    return {}
                })

                if (toDelete == null) {
                    toDelete = []
                }

                setObjectivesToDelete(toDelete)
                setDeleteObjectivesModalOpen(true)

                return false
            },
            customToolbar: () => {
                return (
                    <Fragment>
                        <Tooltip title={t("objective.clear-objectives")}>
                            <IconButton onClick={() => setClearDataModalOpen(true)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={t("objective.assign-objective")}>
                            <IconButton onClick={() => setAddObjectivesModalOpen(true)}>
                                <AddIcon />
                            </IconButton>
                        </Tooltip>
                    </Fragment >
                );
            }
        }

        const columnRender = (dataIndex, fieldName) => {
            var value = currentNodeObjectives.map(objId => objectives[objId])[dataIndex]
            if (value == null) {
                value = { [fieldName]: "Bad Objective Data" }
            }
            return <Box >{value[fieldName] || "-"}</Box>
        }

        const columns = [
            {
                name: "Title",
                label: t("objective.title"),
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        var value = currentNodeObjectives.map(objId => objectives[objId])[dataIndex]
                        if (value == null) {
                            value = { Title: "Bad Objective Data" }
                        }
                        return <Box className={classes.clickableText} >{value.Title}</Box>
                    }
                }
            },
            {
                name: "Description",
                label: t("common.description"),
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => columnRender(dataIndex, "Description")
                }
            },
            {
                name: "CreatedAt",
                label: t("common.created-at"),
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => columnRender(dataIndex, "CreatedAt")
                }
            },
            {
                name: "DueTime",
                label: t("common.due-at"),
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => columnRender(dataIndex, "DueTime")
                }
            },
            {
                name: "Active",
                label: t("common.active"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        var value = currentNodeObjectives.map(objId => objectives[objId])[dataIndex]
                        if (value == null) {
                            value = { Active: "Bad Objective Data" }
                        }
                        return <Chip size={"small"} label={String(value.Active).toUpperCase()} />
                    }
                }
            }
        ]

        return (
            <MuiThemeProvider>
                <MUIDataTable
                    title={t("objective.objectives")}
                    data={currentNodeObjectives.map(id => objectives[id])}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
        )
    }

    function renderContent() {
        const tabs = [
            {
                name: t("hierarchy.metadata"),
                content: renderMetadata()
            },
            {
                name: t('hierarchy.selling-days'),
                content: renderSellingWeeks()
            },
            {
                name: t('hierarchy.feature-flags'),
                content: renderFeatureFlags()
            }
            // {
            //     name: t("objective.objectives"),
            //     content: renderObjectives()
            // }
        ]
        return (
            <ScrollableTabs
                tabs={tabs}
            />
        )
    }

    function handleDrop(file) {
        if (file == null) return
        setFile(file)
    }

    function deleteNodeModal() {
        const dataList = deleteChildrenFlag ? [currentNode.id, ...(currentNode.Children != null ? currentNode.Children : [])] : [currentNode.id]
        const deleteData = getNodesForIds(dataList)

        return (
            <DeleteModal
                open={deleteNodeModalOpen}
                data={deleteData}
                handleCancel={() => {
                    setDeleteNodeModalOpen(false)
                    setDeleteChildrenFlag(false)
                }}
                handleDone={() => {
                    dispatch(deleteNode(currentNode.id, deleteChildrenFlag, () => {
                        setDeleteNodeModalOpen(false)
                        setDeleteChildrenFlag(false)
                        props.history.push("/hierarchies")
                    }))
                }}
            />
        )
    }

    function addParentModal() {
        return (
            <GenericPickerModal
                handleCancel={() => setAddParentModalOpen(false)}
                handleDone={selectedNodes => handleParentNodeSelection(selectedNodes)}
                open={addParentModalOpen}
                handleSelection={() => { }}
                selected={currentNode != null ? [currentNode.id, ...(currentNode?.Parents || []), ...currentNodeChildren] : []}
                title={t('hierarchy.add-parents')}
                getAllData={(callback) => dispatch(getHierarchy(callback))}
                currentSelection={[]}
                data={Object.values(hierarchy)}
                searchTitle={t('hierarchy.parents')}
                idField="id"
                valueField="DisplayName"
                singleSelection
            />
        )
    }

    function addChildModal() {
        return (
            <GenericPickerModal
                handleCancel={() => setAddChildModalOpen(false)}
                handleDone={selectedNodes => handleChildNodeSelection(selectedNodes)}
                open={addChildModalOpen}
                handleSelection={() => { }}
                selected={currentNode != null ? [currentNode.id, ...currentNodeChildren, ...(currentNode?.Parents || [])] : []}
                title={t('hierarchy.add-children')}
                getAllData={(callback) => dispatch(getHierarchy(callback))}
                currentSelection={[]}
                data={Object.values(hierarchy)}
                searchTitle={t('hierarchy.children')}
                idField="id"
                valueField="DisplayName"
            />
        )
    }

    function addBarcodeModal() {
        return (
            <Dialog
                open={addBarcodeModalOpen}
            >
                <DialogTitle>
                    {t('hierarchy.add-barcode')}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        onChange={(event) => setBarcodeValue(event.target.value)}
                        value={barcodeValue}
                        label={t('hierarchy.barcode-value')}
                        margin="dense"
                        variant="outlined"

                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setAddBarcodeModalOpen(false)
                            setBarcodeValue("")
                        }}>
                        {t('common.cancel')}
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => {
                            handleUpdateBarcodes()
                        }}>
                        {t('common.add')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    function addUsersModal() {
        return (
            <GenericPickerModal
                handleCancel={handleAddUserModalCancel}
                handleDone={selectedNodes => handleUpdateUsers(selectedNodes)}
                open={addUserModalOpen}
                handleSelection={() => { }}
                selected={Object.values(currentNodeUsers)}
                title={t('user.add-users')}
                currentSelection={Object.values(currentNodeUsers)}
                getAllData={(callback) => dispatch(getUsers(callback))}
                data={Object.values(users)}
                searchTitle={t('user.users')}
                idField="id"
                valueField="name"

                infiniteLoading
                hasNextPage={hasNewData || firstUserFetch}
                isNextPageLoading={loadingUsers}
                loadNextPage={getNextPage}
            />
        )
    }

    function deleteRelationshipModal() {
        return (
            <DeleteModal
                handleCancel={() => {
                    setDeleteRelationshipModalOpen(false)
                    setRelationshipsToDelete([])
                }}
                handleDone={data => {
                    handleRelationshipDeletion(data);
                }}
                data={getNodesForIds(relationshipsToDelete)}
                open={deleteRelationshipModalOpen}
            />
        )
    }

    function deleteBarcodeModal() {
        return (
            <DeleteModal
                handleCancel={() => {
                    setDeleteBarcodeModalOpen(false)
                }}
                handleDone={data => {
                    dispatch(updateBarcodesForNode(currentNode.id, [], () => {
                        setFetchBarcodes(true)
                        setDeleteBarcodeModalOpen(false)
                    }))
                }}
                data={getBarcodes(barcodesToDelete)}
                open={deleteBarcodeModalOpen}
            />
        )
    }

    function deleteUsersModal() {
        return (
            <DeleteModal
                handleCancel={() => {
                    setDeleteUserModalOpen(false)
                }}
                handleDone={data => {

                    var userData = data.map(item => item.id)

                    var values = Object.values(currentNodeUsers).filter(item => !userData.includes(item))

                    dispatch(updateUsersForNode(currentNode.id, values, () => {
                        setFetchNodeUsers(true)
                        setDeleteUserModalOpen(false)
                    }))
                }}
                data={getNodeUsers(usersToDelete)}
                open={deleteUserModalOpen}
            />
        )
    }

    function handleFileUploadDone(file, fileType) {
        parseUpload(file[0])
    }

    function fileDropModal() {
        return (
            <FileDropModal
                fileType="csv"
                title={t('hierarchy.upload-selling-days')}
                open={addSellingWeeksModalOpen}
                message={t('hierarchy.upload-selling-days-csv')}
                handleDone={(file, fileType) => handleFileUploadDone(file, fileType)}
                handleCancel={() => setAddSellingWeeksModalOpen(false)}
            />
        )
    }

    function deleteSellingWeeksModal() {
        return (
            <DeleteModal
                handleCancel={() => {
                    setDeleteSellingWeeksModalOpen(false)
                }}
                handleDone={data => {
                    dispatch(clearSellingWeeksForNode(currentNode.id, () => {
                        setFetchNodeSellingWeeks(true)
                        setDeleteSellingWeeksModalOpen(false)
                    }))
                }}
                data={[]}
                open={deleteSellingWeeksModalOpen}
            />
        )
    }

    function addObjectivesModal() {
        return (
            <GenericPickerModal
                handleCancel={handleAddObjectivesModalCancel}
                handleDone={selectedNodes => handleUpdateObjectives(selectedNodes)}
                open={addObjectivesModalOpen}
                handleSelection={() => { }}
                selected={currentNodeObjectives}
                title={t('objective.add-objectives')}
                getAllData={(callback) => dispatch(getObjectives([ObjectiveType().admin_route.key], callback))}
                currentSelection={[]}
                data={Object.values(objectives)}
                searchTitle={t('objective.objectives')}
                idField="id"
                valueField="Title"
            />
        )
    }

    function deleteObjectivesModal() {
        return (
            <DeleteModal
                handleCancel={() => {
                    setDeleteObjectivesModalOpen(false)
                }}
                handleDone={data => handleDeleteObjectives(data)}
                data={getNodeObjectives(objectivesToDelete)}
                open={deleteObjectivesModalOpen}
            />
        )
    }

    function clearObjectivesModal() {
        return (
            <Dialog open={clearDataModalOpen}>
                <DialogTitle>
                    {t('objective.confirm-clear')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t('objective.clear-objectives-description')}
                    </DialogContentText>
                    <DialogContentText>
                        {t('common.remove-description')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setClearDataModalOpen(false)
                    }}>
                        {t('common.cancel')}
                    </Button>
                    <Button onClick={() => {
                        dispatch(clearObjectivesForNode(currentNode.id, () => {
                            setClearDataModalOpen(false)
                        }))
                    }}>
                        {t('common.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <Box>
            {loading ? <Loading /> :
                <HeaderBlock
                    title={currentNode.DisplayName}
                    right={
                        <ButtonGroup>
                            < Button
                                variant="outlined"
                                color="primary"
                                onClick={() => {
                                    setDeleteNodeModalOpen(true)
                                    setDeleteChildrenFlag(true)
                                }}
                            >
                                {t('hierarchy.delete-node-and-children')}
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setDeleteNodeModalOpen(true)}
                            >
                                {t('hierarchy.delete-node')}
                            </Button>
                        </ButtonGroup>
                    }
                />
            }

            {deleteNodeModal()}
            {addParentModal()}
            {addChildModal()}
            {addBarcodeModal()}
            {addUsersModal()}
            {addObjectivesModal()}

            {deleteRelationshipModal()}
            {deleteBarcodeModal()}
            {deleteUsersModal()}
            {deleteSellingWeeksModal()}
            {deleteObjectivesModal()}

            {clearObjectivesModal()}

            {fileDropModal()}

            <CustomizedSnackbars
                handleClose={() => setError(null)}
                open={error != null}
                variant="error"
                message={error} />
            < PageContainer >
                {renderContent()}
            </PageContainer >
        </Box >
    )
}

ViewHierarchyPage.propTypes = {

}

export default ViewHierarchyPage
